import { useTranslation } from "react-i18next";
import errorIcon from "../../assets/icons/cross.svg";
import "../EmptyState/EmptyState.css";

const HELP_READER_URL = "https://portal.igpublish.com/help/reader";

const linkStyle = {
  display: "inline-block",
  color: "var(--secondary-color)",
  fontSize: "14px",
  wordBreak: "break-all",
  textDecoration: "underline",
};

/**
 * Browser CORS blocks (and similar opaque network failures) never expose
 * `error.response`. Axios surfaces them as Network Error / ERR_NETWORK.
 * Only use this for the content-server validate call.
 */
export const isCorsBlockedValidateError = (error) => {
  if (!error || error.response) return false;
  return (
    error.code === "ERR_NETWORK" ||
    error.message === "Network Error"
  );
};

const UnauthorizedDomain = () => {
  const { t } = useTranslation();

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        <img
          className="empty-state-icon"
          src={errorIcon}
          alt={t("unauthorizedDomain.errorAlt")}
        />
        <h1 className="empty-state-title">{t("unauthorizedDomain.title")}</h1>
        <p className="empty-state-description">
          {t("unauthorizedDomain.description")}
          <br />
          {t("unauthorizedDomain.moreInfo")}
        </p>
        <a
          style={linkStyle}
          href={HELP_READER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {HELP_READER_URL}
        </a>
      </div>
    </div>
  );
};

export default UnauthorizedDomain;
